import * as actionsTruckKanban from '../actions/truckKanbanAction';
import HttpService from './HttpService';
import { translate, showMessageToastCustom, getUrlPhysicalConfirmationApi } from '../utils/util';
import { startLoading, endLoading } from '../actions/loadingAction';

const httpService = new HttpService(getUrlPhysicalConfirmationApi(window));

export default class TruckKanbanService {
    static searchMvi(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                let url = `/api/mvi`;
                httpService.instance.get(url, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionsTruckKanban.updateMvi(response.data.data));
                    }
                    if (callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback();
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getLabelsPaged(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/mvi/labels/paged`;
                httpService.instance.get(url, { params: filter },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response && response.data.data) {
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getLabels(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/mvi/labels`;
                httpService.instance.get(url, { params: filter },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response && response.data.data) {
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getLabelCim(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/mvi/labels/cim`;
                httpService.instance.get(url, { params: filter },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response && response.data.data) {
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getLabelsCimComposer(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/mvi/labels/cim/list`;
                httpService.instance.get(url, { params: filter },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response.status === 200 && callback) {
                            callback(response?.data?.data);
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static sendReportFileMvi(printer, id, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                let url = `/api/mvi/report/printer/${id}`;
                httpService.instance.post(url, printer, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && callback) {
                        callback();
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback();
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getReportMvi(id, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                let url = `/api/mvi/pdf/${id}`;
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data && callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback();
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getReportSpaceXD(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/mvi/report/labels`;
                httpService.instance.get(url, { params: filter },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response && response.data.data) {
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static createMvi(mvi, callback) {
        const url = '/api/mvi';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, mvi).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        const data = response.data.data;
                        showMessageToastCustom(translate('general.info'), `MVI ${data.mvi.id} criado com sucesso.`, 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        if (callback && data) {
                            callback(data);
                        }
                    }

                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback();
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getTransmissionPaged(filter, report, callback) {
        const url = `/api/log/filter`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        if (!report) {
                            dispatch(actionsTruckKanban.setTransmissionsList(response.data?.data));
                        }
                        if (callback) {
                            callback(response.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getReportMviList(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                const url = `/api/mvi/report`;
                dispatch(startLoading());
                httpService.instance.get(url,
                    {
                        params: filter
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getHighCostMaterialPaged(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/highcostmaterial/paged`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionsTruckKanban.setHighCostMaterials(response.data.data));
                    }
                    if (callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static addHighCostMaterial(item, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/highcostmaterial`, item, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data) {
                        if (callback) {
                            callback(response.data?.success);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static updateHighCostMaterial(item, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(`/api/highcostmaterial`, item, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data) {
                        if (callback) {
                            callback(response.data?.success);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static deleteHighCostMaterial(id, callback) {
        const url = '/api/highcostmaterial/' + id;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(url).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static deleteSelected(ids, callback) {
        if (navigator.onLine) {
            const url = `/api/highcostmaterial/selected`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(url, ids, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (result.data.success) {
                        showMessageToastCustom(translate('general.info'), result.data.message, 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), result.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    if (callback) callback()
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static insertShedArea(postObj, callback) {
        const url = '/api/shedarea';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, postObj).then((response) => {
                    if (callback) {
                        callback(response.data.success);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static updateShedArea(putObj, callback) {
        const url = '/api/shedarea';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, putObj).then((response) => {
                    if (callback) {
                        callback(response.data.success);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getShedAreaPaged(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/shedarea`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionsTruckKanban.shedAreaPaged(response.data.data));
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');

                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
        callback();
    }

    static deleteShedArea(id, callback) {
        if (navigator.onLine) {
            const url = `/api/shedarea/${id}`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.delete(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static deleteShedAreaSelected(ids, callback) {
        if (navigator.onLine) {
            const url = `/api/shedarea/selected`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(url, ids, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    if (callback) callback()
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static finishMvi(mvi, callback) {
        if (navigator.onLine) {
            const url = `/api/mvi/close/${mvi}`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    if (callback) callback()
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static setFilter(filter) {
        return (dispatch) => { dispatch(actionsTruckKanban.setFilter(filter)); };
    }

    static addMviItem(mvi) {
        return (dispatch) => {
            dispatch(actionsTruckKanban.addMviItem(mvi));
        };
    }

    static addLabel(label) {
        return (dispatch) => {
            dispatch(actionsTruckKanban.addLabel(label));
        };
    }

    static removeLabel(label) {
        return (dispatch) => {
            dispatch(actionsTruckKanban.removeLabel(label));
        };
    }

    static clearLabel() {
        return (dispatch) => {
            dispatch(actionsTruckKanban.clearLabel());
        };
    }
}